import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M21.6 1a3.56 3.56 0 0 0-2.23-.9H6.75a3.5 3.5 0 0 0-3.5 3.5v15.5a3.75 3.75 0 0 1-1.49 3l-.11.08a1 1 0 0 0-.35 1.12 1 1 0 0 0 1 .68h13a1 1 0 0 0 .6-.2l.11-.08a5.77 5.77 0 0 0 2.29-4.58v-9.8a.25.25 0 0 1 .25-.25h2.25a2 2 0 0 0 2-2v-3.5A3.5 3.5 0 0 0 21.6 1M6.75 14.32a.75.75 0 0 1 0-1.5h7.5a.75.75 0 0 1 0 1.5ZM12 17.57a.76.76 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 .75.75m-6-12a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.76.76 0 0 1 6 5.57m8.25 4.75h-5.5a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 0 1.5m6.5-3.75a.5.5 0 0 1-.5.5H18.5a.25.25 0 0 1-.25-.25V3.71c0-.17 0-1.62 1-1.64a1.52 1.52 0 0 1 1 .39 1.5 1.5 0 0 1 .49 1.11Z"
    }, null, -1)
  ]));
}
const moneyCashierReceipt = { render };
export {
  moneyCashierReceipt as default,
  render
};
//# sourceMappingURL=money-cashier-receipt.svg.js.map
